module.exports = __webpack_public_path__ + "static/media/2.7aaeffa8.png";